/* Tiroir panier de Dawn, adapté à la copie de klikcamera.com (snippets/cart-drawer.liquid, assets/kc-panier.css) :
   - le contenu du tiroir (.drawer__inner) est redessiné en entier après chaque changement du panier ;
   - la position de défilement est gardée quand le tiroir est déjà ouvert (ajout d'un accessoire, quantité) ;
   - « Vous aimerez aussi » : ajout d'un accessoire (KC.cart.add) et liste des variantes ;
   - la barre « livraison offerte » se remplit en 1 s comme sur klik.
   Compatible avec le bouton d'ajout de Dawn (product-form.js) et KC.cart.add() (kc-core.js) : renderContents(). */

const KCPanier = {
  defilement(root) {
    const el = root && root.querySelector('.kc-panier__contenu');
    return el ? el.scrollTop : 0;
  },

  restaurerDefilement(root, top) {
    const el = root && root.querySelector('.kc-panier__contenu');
    if (el && top) el.scrollTop = top;
  },

  /* Barre de progression : part de la valeur précédente et se remplit (transition CSS de 1 s). */
  suivreBarres(container) {
    if (!container || container.__kcBarres) return;
    container.__kcBarres = true;
    const actuelle = container.querySelector('.kc-livraison');
    let precedente = actuelle ? parseFloat(actuelle.dataset.kcProgression) || 0 : 0;
    if (actuelle) actuelle.__kcVue = true;
    const verifier = () => {
      const barre = container.querySelector('.kc-livraison');
      if (!barre) {
        if (!container.querySelector('.kc-ligne')) precedente = 0;
        return;
      }
      if (barre.__kcVue) return;
      barre.__kcVue = true;
      const cible = parseFloat(barre.dataset.kcProgression) || 0;
      if (Math.abs(cible - precedente) > 0.0001) {
        barre.style.setProperty('--kc-progression', precedente);
        barre.getBoundingClientRect();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => barre.style.setProperty('--kc-progression', cible));
        });
      }
      precedente = cible;
    };
    new MutationObserver(verifier).observe(container, { childList: true, subtree: true });
  },

  async ajouter(bouton) {
    if (bouton.classList.contains('is-loading')) return;
    const carte = bouton.closest('[data-kc-sugg]');
    const liste = carte && carte.querySelector('[data-kc-sugg-select]');
    const id = Number(liste ? liste.value : bouton.dataset.variantId);
    const erreur = carte && carte.querySelector('.kc-sugg__erreur');
    if (!id) return;
    if (erreur) {
      erreur.hidden = true;
      erreur.textContent = '';
    }
    bouton.classList.add('is-loading');
    bouton.setAttribute('aria-disabled', 'true');
    try {
      if (window.KC && window.KC.cart && typeof window.KC.cart.add === 'function') {
        await window.KC.cart.add([{ id, quantity: 1 }]);
      } else {
        await KCPanier.ajouterSansKC(id);
      }
    } catch (e) {
      const message =
        (e && (e.description || e.message)) || (window.cartStrings && window.cartStrings.error) || 'Une erreur est survenue.';
      if (erreur && erreur.isConnected) {
        erreur.textContent = message;
        erreur.hidden = false;
      }
      console.error(e);
    } finally {
      if (bouton.isConnected) {
        bouton.classList.remove('is-loading');
        bouton.removeAttribute('aria-disabled');
      }
    }
  },

  async ajouterSansKC(id) {
    const tiroir = document.querySelector('cart-drawer');
    const body = { items: [{ id, quantity: 1 }] };
    if (tiroir) {
      body.sections = tiroir.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    const res = await fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const json = await res.json();
    if (!res.ok || json.status) throw json;
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kc', productVariantId: id, cartData: json });
    if (tiroir) {
      json.id = id;
      tiroir.renderContents(json);
    }
    return json;
  },

  changerVariante(liste) {
    const option = liste.selectedOptions[0];
    const carte = liste.closest('[data-kc-sugg]');
    if (!option || !carte) return;
    const prix = carte.querySelector('[data-kc-sugg-prix]');
    const barre = carte.querySelector('[data-kc-sugg-barre]');
    const badge = carte.querySelector('[data-kc-sugg-badge]');
    const image = carte.querySelector('[data-kc-sugg-image]');
    const bouton = carte.querySelector('[data-kc-sugg-ajout]');
    if (prix) prix.textContent = option.dataset.prix || '';
    if (barre) {
      barre.textContent = option.dataset.barre || '';
      barre.hidden = !option.dataset.barre;
    }
    if (badge) {
      badge.textContent = (option.dataset.badge || '').replace(' %', ' %');
      badge.hidden = !option.dataset.badge;
    }
    if (image && option.dataset.image) image.src = option.dataset.image;
    if (bouton) bouton.dataset.variantId = option.value;
  },
};
window.KCPanier = KCPanier;

document.addEventListener('click', (event) => {
  const bouton = event.target.closest('[data-kc-sugg-ajout]');
  if (!bouton) return;
  event.preventDefault();
  KCPanier.ajouter(bouton);
});

document.addEventListener('change', (event) => {
  const liste = event.target.closest('[data-kc-sugg-select]');
  if (liste) KCPanier.changerVariante(liste);
});

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    KCPanier.suivreBarres(this);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // Sur la page /cart, le panier a pu changer sans le tiroir : on le redessine à l'ouverture.
    if (document.getElementById('main-cart-items')) this.refresh();
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (containerToTrapFocusOn) trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    const dejaOuvert = this.classList.contains('active');
    const top = dejaOuvert ? KCPanier.defilement(this) : 0;
    this.productId = parsedState.id;

    if (!parsedState.sections || !parsedState.sections['cart-drawer']) {
      this.refresh().then(() => this.open());
      return;
    }

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState.sections[section.id]) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.classList.toggle('is-empty', !!this.querySelector('.drawer__inner-empty'));
    KCPanier.restaurerDefilement(this, top);

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  /* Redessine le contenu du tiroir depuis la section « cart-drawer » (panier modifié ailleurs). */
  refresh() {
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.querySelector('.drawer__inner');
        const cible = this.querySelector('.drawer__inner');
        if (!source || !cible) return;
        const top = this.classList.contains('active') ? KCPanier.defilement(this) : 0;
        cible.innerHTML = source.innerHTML;
        this.classList.toggle('is-empty', !!cible.querySelector('.drawer__inner-empty'));
        KCPanier.restaurerDefilement(this, top);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  connectedCallback() {
    // Événement « vue » de Dawn (classe de base), sans l'abonnement de CartItems remplacé ci-dessous.
    const base = Object.getPrototypeOf(CartItems.prototype);
    if (base && typeof base.connectedCallback === 'function') base.connectedCallback.call(this);

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // Déjà redessiné par renderContents() (bouton d'ajout de Dawn, KC.cart.add) ou par cart.js (quantités).
      if (['cart-items', 'product-form', 'kc'].includes(event.source)) return;
      return this.onCartUpdate();
    });
  }

  onCartUpdate() {
    const tiroir = document.querySelector('cart-drawer');
    return tiroir && tiroir.refresh ? tiroir.refresh() : Promise.resolve();
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* Barre « livraison offerte » de la page /cart */
(function () {
  const init = () => KCPanier.suivreBarres(document.getElementById('main-cart-items'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
